module.exports = __webpack_public_path__ + "static/media/abogados-logo.9451a428.png";